export const queryKeys = {
	courses: (queryParams?: Record<string, string | string[]>) =>
		['courses', queryParams] as const,
	courseAutocomplete: (search: string) =>
		['course-autocomplete', search] as const,
	course: (courseSlug: string) => ['course', courseSlug] as const,
	topic: (courseSlug: string, topicSlug: string) =>
		['course', courseSlug, 'topic', topicSlug] as const,
	topicRepository: (courseSlug: string, topicSlug: string) =>
		['topic-repository', courseSlug, topicSlug] as const,
	tags: (queryParams?: Record<string, string | string[]>) =>
		['tags', queryParams] as const,
}
